export const CURRENCY_0 = {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
};

export const CURRENCY_2 = {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
};

export const CURRENCY_2_NO_SYMBOL = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
};

export const CURRENCY_MIN_0_MAX_2 = {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
};

export const ODOMETER = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
};

export const FUEL_CONSUMPTION = {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
};

export default {
    CURRENCY_0,
    CURRENCY_2,
    CURRENCY_MIN_0_MAX_2,
    ODOMETER,
    FUEL_CONSUMPTION,
    CURRENCY_2_NO_SYMBOL,
};
